/**
 * Created by Jew on 9/12/2018.
 */
/**
 * Created by Jew on 9/12/2018.
 */
import { Component, HostListener, OnInit, ViewChild, OnDestroy, ElementRef, Renderer2, ViewContainerRef } from '@angular/core';
import { IdexService } from 'app/idex.service';
import { DocListComponent } from '../doclist/doclist.component';
import { TranslateService } from '@ngx-translate/core';
import { Toast } from 'app/shared/toast/toast';
import { Path} from '../../shared/path';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { UploadService } from '../upload.service';
import { AppComponent } from '../../app.component';
import { UploadProgressComponent } from '../upload-progress/upload-progress.component';
import { FileUploader} from '../file-uploader';
import { DownloadZipComponent } from '../download-zip/download-zip.component';
import { ConfirmDeleteComponent } from '../confirm-delete/confirm-delete.component';
import { CreateFolderComponent } from '../create-folder/create-folder.component';
import { CreateOneDriveComponent } from '../onedrive/create-onedrive.component';
import { CreateGoogleDriveComponent } from '../google-drive/create-google-drive.component';

@Component({
   selector: 'app-share-with-me',
   templateUrl: './share-with-me.component.html',
   styleUrls: ['./share-with-me.component.css'],
})
export class SharedWithMeComponent implements OnInit, OnDestroy {
   @ViewChild(DocListComponent, {static: true}) docList: DocListComponent;
   @ViewChild('toolbar') toolbar: ElementRef;
   @ViewChild('fileUpload') fileUpload: any;

   private path: string;
   paths: any[];
   doc: any;
   private page = 1;
   private size = 50;
   result: any;
   selectedItems: any[] = [];
   private subscriber: Subscription;

   success: any;
   content: any;
   doc_id: any;
   object_file: any;

   settype = false;
   position = 'below';
   @ViewChild('progress') progress: UploadProgressComponent;

   sharer: any;
   title: string;
   public: boolean;

   isDownload: boolean;
   permissionLevel: number;
   isListDoc = false;
   shareId: string;
   shareDocId: string;

   supportFolderUpload: boolean;
   limit: any;
   public canDrag = false;

   private uploadCallback = {
      init: (files) => {
         this.progress.init(files);
      },
      quotaExceed: (i: number, size: number, error: string) => {
         this.progress.quotaExceed(i, size, error);
      },
      limitExceed: (i: number, size: number) => {
         this.progress.limitExceed(i, size, this.limit);
      },
      progress: (i: number, progress: number) => {
         this.progress.update(i, progress);
      },
      cancelUpload: (i: number, error: string) => {
         this.progress.cancelUpload(i, error);
      },
      complete: () => {
         this.progress.complete();
         setTimeout(() => {
            this.progress.hide();
            this.showDocument();
         }, this.progress.calcDelay());
      }
   };

   constructor(public service: IdexService, private container: ViewContainerRef,
               private router: Router, private route: ActivatedRoute,
               private translate: TranslateService, private renderer: Renderer2,
               private upload: UploadService, public dialog: MatDialog,
               private app: AppComponent, private toast: Toast,
               public uploader: FileUploader) {}

   ngOnInit() {
      this.docList.items = undefined;
      this.subscriber = this.route.url.subscribe(url => {
         this.sharer = this.service.user.email;
         this.public = false;
         this.isListDoc = url.length > 0;

         if (!this.service.shareDocId) {
            this.service.shareId = sessionStorage.getItem('shareId');
            this.service.shareDocId = sessionStorage.getItem('shareDocId');
            this.service.isDownload = sessionStorage.getItem('isDownload') === 'true';
            this.service.permissionLevel = parseInt(sessionStorage.getItem('permissionLevel'), 10);

            sessionStorage.removeItem('shareId');
            sessionStorage.removeItem('shareDocId');
            sessionStorage.removeItem('isDownload');
            sessionStorage.removeItem('permissionLevel');
         }
         sessionStorage.setItem('shared', 'true');
         this.path = decodeURIComponent(url.join('/'));
         this.createBreadcrumb();
         this.showDocument();
         this.upload.getLimitSize();
      });
      const input = document.createElement('input');
      this.supportFolderUpload = ('webkitdirectory' in input
         || 'mozdirectory' in input
         || 'odirectory' in input
         || 'msdirectory' in input
         || 'directory' in input);
   }

   ngOnDestroy(): void {
      this.subscriber.unsubscribe();
   }

   @HostListener('window:beforeunload', ['$event'])
   unload($event: any) {
      sessionStorage.setItem('shareId', this.service.shareId);
      sessionStorage.setItem('shareDocId', this.service.shareDocId);
      sessionStorage.setItem('isDownload', this.service.isDownload.toString());
      sessionStorage.setItem('permissionLevel', this.service.permissionLevel.toString());
   }

   @HostListener('window:scroll')
   scrollFixed() {
      if (this.toolbar) {
         this.toolbar.nativeElement.style.left = (240 - window.scrollX) + 'px';
      }
   }

   private createBreadcrumb(): void {
      this.translate.get('main.shared-with-me').subscribe(files => {
         if (this.path.length === 0) {
            this.paths = [{name: files}];
            return;
         }

         const paths = [];
         paths.push({name: files, path: '/'});

         let fullPath = '';
         const array = this.path.match(/[^/]+/g);
         for (let i = 0; i < array.length; i++) {
            if (i === array.length - 1) {
               fullPath = null;
            } else {
               if (fullPath.length > 0) { fullPath += '/'; }
               fullPath += array[i];
            }
            paths.push({ name: array[i], path: fullPath });
         }
         this.paths = paths;
      });
   }

   showDocument() {
      this.selectedItems = [];
      this.page = 1;
      if (this.isListDoc) {
         this.loadShareDocuments();
      } else {
         this.service.listShareWithMeDocuments(this.page, this.size)
            .subscribe(
               data => {

                  this.docList.setItems(data.items, data.hasMore, data.metadata);
                  document.body.scrollTop = 0;
               }, error => {
                  if (error.status === 404) {
                     this.router.navigate(['/sharedwithme']);
                  }
               });
      }
   }

   onLoadMore() {
      if (this.isListDoc) {
         this.loadShareDocuments();
      } else {
         this.service.listShareWithMeDocuments(this.page + 1, this.size)
            .subscribe(
               data => {
                  this.docList.addItems(data.items, data.hasMore);
                  if (data.hasMore) {
                     this.page++;
                  }
               });
      }
   }

   onClickItem(item: any) {
      let path = location.pathname;
      const idex = '/idex';
      if (path.startsWith(idex)) {
         path = path.substring(idex.length);
      }

      if (item.shareId) {
         this.service.shareId = item.shareId;
         this.service.shareDocId = item.id;
         this.service.isDownload = item.isDownload;
         this.service.permissionLevel = item.permissionLevel;
      }

      localStorage.setItem('url', Path.combine(path));
      if (item.isFolder) {
         const url = Path.combine('/sharedwithme', encodeURIComponent(this.path), encodeURIComponent(item.name));
         this.router.navigate([url]);
      } else {
         if (this.isListDoc) {
            this.router.navigate(['/file', item.id]);
         } else {
            this.router.navigate(['/share', this.service.shareId]);
         }
      }
   }

   navigate(path: string) {
      this.doc = undefined;
      if (path) {
         const url = Path.combine('/sharedwithme', path);
         this.router.navigate([url]);
      } else {
         this.router.navigate(['/sharedwithme']);
      }
   }

   loadShareDocuments() {
      this.service.listShareDocuments(this.path, this.page, this.size, this.sharer,
         this.service.shareDocId, 'Private', this.service.isDownload, this.service.permissionLevel)
         .subscribe(
            data => {
               this.docList.permissionLevel = this.service.permissionLevel;
               this.docList.setItems(data.items, data.hasMore);
               document.body.scrollTop = 0;
            }, error => {
               this.router.navigate(['/login']);
            });
   }

   onItemAllSelect(chk: any) {
      for (let i = 0; i < this.docList.items.length; i++) {
         this.docList.items[i].selected = chk.checked;
         const index = this.selectedItems.indexOf(this.docList.items[i]);
         if (this.docList.items[i].selected) {
            if (index === -1) {
               this.selectedItems.push(this.docList.items[i]);
            }
         } else {
            if (index !== -1) {
               this.selectedItems.splice(index, 1);
            }
         }
      }
   }

   selectedDownload() {
      const listIds = [];
      let name = 'Archive';
      if (this.selectedItems) {
         if (this.selectedItems.length === 1) {
            name = this.selectedItems[0].name;
         }
         for (const itemSel of this.selectedItems) {
            listIds.push(itemSel.id);
         }
      }

      this.dialog.open(DownloadZipComponent, {
         disableClose: true,
         data: {
            idList: listIds,
            name: name,
            service: this.service
         }
      });
   }

   confirmDelete(): void {
      const dialogRef = this.dialog.open(ConfirmDeleteComponent, {
         disableClose: true,
         data: {
            service: this.service, listItem: this.selectedItems.sort((a: any, b: any) => a.name < b.name ? -1 : 1),
            isMultiSelect: true, data: this, toast: this.toast, translate: this.translate
         }
      });
      dialogRef.afterClosed().subscribe(result => {
         if (result) {
            this.selectedItems = [];
         }
      });
   }

   newFolder() {
      this.canDrag = false;
      this.shareDocId = this.service.shareDocId;
      const dialogRef = this.dialog.open(CreateFolderComponent, {
         disableClose: true,
         data: this,
      });
      dialogRef.componentInstance.toast = this.toast;
      dialogRef.componentInstance.translate = this.translate;
      dialogRef.afterClosed().subscribe(result => {
         this.canDrag = true;
      });
   }

   startOnedrive(type: any) {
      this.canDrag = false;
      const onedrive = this.dialog.open(CreateOneDriveComponent, {
         disableClose: true,
         data: this
      });
      onedrive.componentInstance.doctype = type;
      onedrive.componentInstance.path = this.path;
      onedrive.afterClosed().subscribe(result => {
         this.canDrag = true;
      });
   }

   startGoogle(type: any) {
      this.canDrag = false;
      const google = this.dialog.open(CreateGoogleDriveComponent, {
         disableClose: true,
         data: {
            filesComponent: this,
            path: this.path,
            type: type
         }
      });
      google.componentInstance.isBusiness = false;
      google.afterClosed().subscribe(result => {
         this.canDrag = true;
      });
   }

   uploadSelected(myFiles: any): void {
      this.uploader.uploadFolder(myFiles, this.upload.limitSize, this.path, null, this.uploadCallback, null, this.service.shareDocId);
   }

   uploadFolder(files: FileList): void {
      this.uploader.uploadFolder(files, this.upload.limitSize, this.path, null, this.uploadCallback, null, this.service.shareDocId);
   }

   uploadNewVersion(event: any): void {
      this.uploader.uploadFolder(event.file, this.upload.limitSize, this.path, null, this.uploadCallback, event.item.id, null, event.isMajor);
   }

   onDragOver(event: DragEvent) {
      if (!this.isListDoc || (this.isListDoc && this.service.permissionLevel < 2)) {
         event.preventDefault();
         event.stopPropagation();
         event.dataTransfer.effectAllowed = 'none';
         event.dataTransfer.dropEffect = 'none';
      } else {
         const data = event.dataTransfer;
         let hasFiles = false;
         if (data.items) {
            for (let i = 0; i < data.items.length; i++) {
               if (data.items[i].kind === 'file') {
                  hasFiles = true;
                  break;
               }
            }
         } else if (data.files && data.files.length > 0) {
            hasFiles = data.files && data.files.length > 0;
         }

         if (hasFiles && !this.uploader.busy) {
            event.preventDefault();
            event.stopPropagation();
            event.dataTransfer.dropEffect = 'copy';
            this.renderer.addClass(this.docList.nativeElement, 'drag-over');
         }
      }
   }

   onDrop(e: DragEvent) {
      e.preventDefault();
      e.stopPropagation();
      this.renderer.removeClass(this.docList.nativeElement, 'drag-over');

      this.uploader.process(e.dataTransfer, this.upload.limitSize, this.path, null, this.uploadCallback, this.service.shareDocId);
   }

   onDragLeave() {
      this.renderer.removeClass(this.docList.nativeElement, 'drag-over');
   }
}
